import { Component, Prop } from 'vue-property-decorator';
import { createNamespace } from 'src/util/bem';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import * as Vue from 'vue-tsx-support';
import Input from 'src/types/iview/Input';

export namespace LimitsVOI {
    export interface PropsI {
        alarm_floor: number;
        alarm_ceiling: number;
        saveSuccess?(): void;
        cancel?(): void;
    }
}


@Component
class LimitsModal extends Vue.Component<LimitsVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    alarm_floor: number | undefined;

    @Prop({
        type: Number,
    })
    alarm_ceiling!: number;


    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    uploading: boolean = false;

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }
    
    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={'上下限查看'}
                width="500"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >   
               <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100}>
                    <form-item label="上限值" prop="alarm_floor" style="display: inline-block;width:45%">
                        <Input readonly   placeholder="请输入" v-model={this.alarm_floor} />
                    </form-item>
                    <form-item label="下限值" prop="alarm_ceiling" style="display: inline-block;width:45%">
                        <Input readonly  placeholder="请输入" v-model={this.alarm_ceiling} />
                    </form-item>
            
               </i-form>
                <div slot="footer">
                </div>
            </Modal>
        );
    }
}

export default function alertLimitsModal(alarm_floor: number, alarm_ceiling: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<LimitsVOI.PropsI>(LimitsModal)({
            alarm_floor,
            alarm_ceiling,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}